export const loadFirebaseAuthSdk = () => import('firebase/auth')

export const createGoogleProvider = async () => {
  const { GoogleAuthProvider } = await loadFirebaseAuthSdk()
  const provider = new GoogleAuthProvider()
  provider.addScope('profile')
  provider.addScope('email')
  provider.setCustomParameters({
    prompt: 'select_account'
  })
  return provider
}

export const createGithubProvider = async () => {
  const { GithubAuthProvider } = await loadFirebaseAuthSdk()
  const provider = new GithubAuthProvider()
  provider.addScope('user:email')
  return provider
}

export const isAllowedEmailDomain = (email: string | null): boolean => {
  return Boolean(email)
}
